module.exports = __webpack_public_path__ + "img/Home_Header.52471dc1.jpg";